import { render } from "./AlertNoRecord.vue?vue&type=template&id=4a7a54a1&scoped=true"
import script from "./AlertNoRecord.vue?vue&type=script&lang=js"
export * from "./AlertNoRecord.vue?vue&type=script&lang=js"

import "./AlertNoRecord.vue?vue&type=style&index=0&id=4a7a54a1&scoped=true&lang=css"

import exportComponent from "/home/ad5coral/ad5.tech/oyadori/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a7a54a1"]])

export default __exports__